<!-- <div style="position: relative;">
  <div *ngIf="editMode" [ngStyle]="panelStyle()">
    <button *ngIf="position > 0" (click)="columnContainer.moveWidgetDown(position)" class="btn btn-sm btn-default btn-danger"
      [ngStyle]="leftStyle()"><i class="fa fa-arrow-left" aria-hidden="true" ></i></button>
    <button *ngIf="!isLast" (click)="columnContainer.moveWidgetUp(position)" class="btn btn-sm btn-default btn-danger" [ngStyle]="rightStyle()"><i class="fa fa-arrow-right" aria-hidden="true" ></i></button>
  </div> -->
<div class="plyca.w.container m-b" [ngClass]="cols()" style="display: inline-block;vertical-align: top;">
  <ng-template #container ></ng-template>
</div>
<!-- </div> -->